import { PipelineStepInstance, PipelineStepType } from './pipelineBuilder.types'
import { defaultStepConfig } from './stepConfigUtils'
import { getCatalogEntry } from './stepCatalog'

export function createStepInstanceForDialog(
    type: PipelineStepType,
    existingSteps: PipelineStepInstance[],
): PipelineStepInstance {
    const catalog = getCatalogEntry(type)
    const sameTypeCount = existingSteps.filter((s) => s.type === type).length
    const id =
        sameTypeCount === 0
            ? `step_${type}`
            : `step_${type}_${sameTypeCount + 1}`

    const defaultConfig = defaultStepConfig(type)
    const config =
        type === 'screening' && sameTypeCount >= 1
            ? {
                  ...(defaultConfig ?? {}),
                  instance_label: `${catalog.label} ${sameTypeCount + 1}`,
              }
            : defaultConfig

    return {
        id,
        type,
        enabled: true,
        order: 0,
        entry: { ...catalog.defaultEntry },
        completion: { ...catalog.defaultCompletion },
        on_complete: JSON.parse(
            JSON.stringify(catalog.defaultOnComplete),
        ) as PipelineStepInstance['on_complete'],
        enter_behavior:
            catalog.defaultEntry.mode === 'manual' ? 'pm_start' : 'auto_start',
        ...(config ? { config } : {}),
    }
}
